import feathersClient, {
    makeServicePlugin,
    BaseModel,
  } from '../../feathers-client';

  class GestionesReconocimientoFacial extends BaseModel {
    constructor(data, options) {
      super(data, options);
    }
    static modelName = 'GestionesReconocimientoFacial';
    static instanceDefaults() {
      return {};
    }
  }
  const servicePath = 'gestiones-reconocimiento-facial';
  const servicePlugin = makeServicePlugin({
    namespaced: true,
    namespace: 'GestionesReconocimientoFacial',
    Model: GestionesReconocimientoFacial,
    service: feathersClient.service(servicePath),
    servicePath,
  });

  feathersClient.service(servicePath).hooks({
    before: { all: [], find: [], get: [], create: [], update: [], patch: [], remove: [] },
    after:  { all: [], find: [], get: [], create: [], update: [], patch: [], remove: [] },
    error:  { all: [], find: [], get: [], create: [], update: [], patch: [], remove: [] },
  });

  export default servicePlugin;
